<se-fe-page>
  <se-fe-header
    seFePageHeader
    seFeDataTitle="Affiliation Access"
    seFeDataSubtitle="An affiliation access component"
    size="750">
  </se-fe-header>
  <div seFePageContent>
    <div class="docs-content">
      <se-fe-card>
        <se-fe-card-header seFeDataTitle="When to use"></se-fe-card-header>
        <se-fe-card-content>
          <p>Use this component to allow top down org access to ancestor organizations</p>
        </se-fe-card-content>
      </se-fe-card>
      <se-fe-card class="form-example">
        <se-fe-card-header seFeDataTitle="Example Code"></se-fe-card-header>
        <se-fe-card-content>
          <se-po-affiliation-access-example></se-po-affiliation-access-example>
        </se-fe-card-content>
      </se-fe-card>
    </div>
  </div>
</se-fe-page>
